import { render, staticRenderFns } from "./NumeroGirDni.vue?vue&type=template&id=74835df3&"
import script from "./NumeroGirDni.vue?vue&type=script&lang=js&"
export * from "./NumeroGirDni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports